import { FieldSchema, StagingRecord, ValidationRule } from './types';

export const SCHEMA: FieldSchema[] = [
  { key: 'fullName', label: 'Customer Name', type: 'string', placeholder: 'e.g. John Doe' },
  { key: 'email', label: 'Email Address', type: 'email', placeholder: 'john@example.com' },
  { key: 'age', label: 'Age', type: 'number', hint: 'Must be between 18 and 120' },
  { key: 'isActive', label: 'Active Membership', type: 'boolean' },
  { key: 'signupDate', label: 'Signup Date', type: 'date' },
];

export const VALIDATION_RULES: ValidationRule[] = [
  { 
    field: 'fullName', 
    type: 'required', 
    message: 'Customer name is required' 
  },
  { 
    field: 'email', 
    type: 'regex', 
    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, 
    message: 'Invalid email format' 
  },
  { 
    field: 'age', 
    type: 'min', 
    value: 18, 
    message: 'Customer must be at least 18 years old' 
  },
  { 
    field: 'age', 
    type: 'max', 
    value: 120, 
    message: 'Age exceeds maximum limit (120)' 
  }
];

export const MOCK_RECORDS: StagingRecord[] = [
  {
    id: 'REC-10928',
    status: 'pending',
    importDate: '2023-10-25',
    data: {
      id: 'cust_1',
      fullName: 'John Doe',
      email: 'john.doe_gmail.com',
      age: 150,
      isActive: true,
      signupDate: '2023-01-15'
    }
  },
  {
    id: 'REC-10929',
    status: 'ready',
    importDate: '2023-10-26',
    data: {
      id: 'cust_2',
      fullName: 'Sarah Smith',
      email: 'sarah.smith@example.com',
      age: 32,
      isActive: true,
      signupDate: '2023-02-20'
    }
  },
  {
    id: 'REC-10930',
    status: 'pending',
    importDate: '2023-10-27',
    data: {
      id: 'cust_3',
      fullName: '',
      email: 'mike@corporate',
      age: 25,
      isActive: false,
      signupDate: '2023-03-10'
    }
  },
  {
    id: 'REC-10931',
    status: 'rejected',
    importDate: '2023-10-24',
    data: {
      id: 'cust_4',
      fullName: 'Spam Bot',
      email: 'spam@bot.net',
      age: 0,
      isActive: false,
      signupDate: '2023-01-01'
    },
    resolvedBy: 'Admin User',
    resolutionNote: 'Account contains clearly fake data and is underage.',
    resolutionDate: '2023-10-24T14:30:00Z'
  },
  {
    id: 'REC-10932',
    status: 'imported',
    importDate: '2023-10-23',
    data: {
      id: 'cust_5',
      fullName: 'Alice Wonder',
      email: 'alice@example.com',
      age: 28,
      isActive: true,
      signupDate: '2023-01-20'
    },
    resolvedBy: 'System',
    resolutionNote: '', // Empty note implies auto-accepted
    resolutionDate: '2023-10-23T10:00:00Z'
  },
  {
    id: 'REC-10933',
    status: 'imported',
    importDate: '2023-10-23',
    data: {
      id: 'cust_6',
      fullName: 'Bob Builder',
      email: 'bob@construction.com',
      age: 45,
      isActive: true,
      signupDate: '2023-02-15'
    },
    resolvedBy: 'Jane Doe',
    resolutionNote: 'Manually corrected the email domain typo before import.',
    resolutionDate: '2023-10-23T15:45:00Z'
  }
];